import { Link } from "react-router-dom";
import { useGetAdminAllhousingQuery } from "../../../../app/features/housing/housingApi";
import { useGetAllCityQuery } from "../../../../app/features/account/accountApi";
import LoadingUi from "../../../../components/LoadingUi/LoadingUi";
import NoData from "../../../../components/NoData/NoData";
import PermissionDenied from "../../../../components/Errors/PermissionDenied";
import SEOData from "../../../../components/SEO/SEO";
import { MdHome } from "react-icons/md";

const AllHousung = () => {
  const { data: housing, isError: housingError, error: housingErrorData, loading: housingLoading } = useGetAdminAllhousingQuery();
  const { data: cityData, loading: cityDataLoading } = useGetAllCityQuery();

  const pendingData = housing?.results?.filter((item) => item?.status === "pending");

  const getCityName = (cityId) => cityData?.find((city) => city.id === cityId)?.name || "—";

  if (housingLoading && cityDataLoading) return <LoadingUi />;
  if (housingError) return <PermissionDenied pageTitle="Housing Request" errorData={housingErrorData} />;

  return (
    <div className="space-y-6">
      <SEOData title="Dashboard || Housing Request" description="Dashboard Housing Request page." canonical={window.location.pathname} />

      {/* Header */}
      <div className="bg-white rounded-2xl border border-brand-border/30 shadow-sm px-6 py-5">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: "var(--brand-gradient)" }}>
            <MdHome size={20} color="white" />
          </div>
          <div>
            <h1 className="font-montserrat text-xl font-bold text-slate-800 leading-tight">Housing Requests</h1>
            <p className="text-xs text-slate-400 mt-0.5">{pendingData?.length ?? 0} pending requests</p>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white rounded-2xl border border-brand-border/30 shadow-sm overflow-hidden">
        {!pendingData?.length ? (
          <div className="flex flex-col items-center justify-center py-16 text-slate-400">
            <MdHome size={36} className="mb-3 opacity-30" />
            <p className="font-semibold text-sm">No pending housing requests</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full">
              <thead>
                <tr className="border-b border-slate-100 bg-slate-50">
                  <th className="px-6 py-3 text-left text-xs font-bold text-slate-400 uppercase tracking-wider">Image</th>
                  <th className="px-6 py-3 text-left text-xs font-bold text-slate-400 uppercase tracking-wider">Name</th>
                  <th className="px-6 py-3 text-left text-xs font-bold text-slate-400 uppercase tracking-wider">Price / mo</th>
                  <th className="px-6 py-3 text-left text-xs font-bold text-slate-400 uppercase tracking-wider">City</th>
                  <th className="px-6 py-3 text-left text-xs font-bold text-slate-400 uppercase tracking-wider">Type</th>
                  <th className="px-6 py-3 text-right text-xs font-bold text-slate-400 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {pendingData.map((apartment) => (
                  <tr key={apartment?.id} className="hover:bg-slate-50 transition-colors">
                    <td className="px-6 py-4">
                      <img src={apartment.images[0]?.image} alt={apartment.name} className="w-14 h-14 object-cover rounded-xl border border-brand-border/20" />
                    </td>
                    <td className="px-6 py-4">
                      <span className="text-sm font-semibold text-slate-700">{apartment.name}</span>
                    </td>
                    <td className="px-6 py-4 text-sm text-slate-500">${apartment?.details?.rent_per_month}</td>
                    <td className="px-6 py-4 text-sm text-slate-500">{getCityName(apartment?.city)}</td>
                    <td className="px-6 py-4">
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-brand-lavender text-brand-primary">{apartment.types}</span>
                    </td>
                    <td className="px-6 py-4 text-right">
                      <Link to={`/admin/dashboard/housing/${apartment?.id}`} target="_blank">
                        <button className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold text-brand-primary bg-brand-lavender hover:opacity-80 transition-colors">
                          View Details
                        </button>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AllHousung;
